export const QUERY_FIELD_NAME = 'query';
